// extracted by mini-css-extract-plugin
export default {"probabiltyContainer":"Probability_probabiltyContainer__k0pcy"};